<section class="faq">
  <h2>Frequently asked questions</h2>
  <app-faq [items]="faqItems"></app-faq>
</section>
